var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isVisible ? _c('div', {
    staticClass: "slider-cart"
  }, [_c('div', {
    staticClass: "slider-cart-header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("footer.shoppingCart")) + " (" + _vm._s(_vm.cartData.length) + ")")]), _c('button', {
    staticClass: "close-btn",
    on: {
      "click": _vm.toggleCart
    }
  }, [_vm._v("×")])]), _vm.cartData.length > 0 ? _c('div', {
    staticClass: "slider-cart-content"
  }, [_vm._l(_vm.cartData, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "cart-item"
    }, [_c('img', {
      staticClass: "item-image",
      attrs: {
        "src": item.images.icon,
        "alt": "Product Image"
      }
    }), _c('div', {
      staticClass: "item-details"
    }, [_c('h4', [_vm._v(_vm._s(item.Name))]), _c('p', [_vm._v(_vm._s(item.Quantity) + " x " + _vm._s(item.price))])]), item._id != '67f0bd1458eeb6f746342b34' ? _c('button', {
      staticClass: "remove-btn",
      on: {
        "click": function ($event) {
          return _vm.removeItemFromCart(item);
        }
      }
    }, [_vm._v(" × ")]) : _vm._e()]);
  }), _c('div', {
    staticClass: "cart-footer"
  }, [_c('div', {
    staticClass: "cart-summary"
  }, [_c('p', [_vm._v(_vm._s(_vm.cartData.length) + " " + _vm._s(_vm.$t("product")) + "(s)")]), _c('p', {
    staticClass: "total-price"
  }, [_vm._v("$" + _vm._s(_vm.totalPrice))])]), _c('div', {
    staticClass: "cart-actions"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function ($event) {
        return _vm.handleActionAndCloseCart('/checkout');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("checkout.checkout")) + " ")]), _c('router-link', {
    staticClass: "btn btn-secondary",
    attrs: {
      "to": {
        name: 'checkout'
      }
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.handleActionAndCloseCart('/checkout');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("checkout.gotocart")) + " ")])], 1)])], 2) : _c('div', {
    staticClass: "cart-empty"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("checkout.yourcartisempty")) + "!")]), _c('button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": function ($event) {
        return _vm.handleActionAndCloseCart('/');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("checkout.shopnow")) + " ")])])]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }